import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-super-social-card',
  templateUrl: './super-social-card.component.html',
  styleUrls: ['./super-social-card.component.scss']
})
export class SuperSocialCardComponent { }
